import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/photography", label: "Photography" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/real-estate", label: "Real Estate" },
  { to: "/learn", label: "Learn" },
  { to: "/workshops", label: "Workshops" },
  { to: "/gift-cards", label: "Gift" },
  { to: "/pricing", label: "Pricing" },
  { to: "/blog", label: "Blog" },
  { to: "/#about", label: "About" },
  { to: "/#contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const go = (to) => {
    setOpen(false);
    if (to.includes("#")) {
      const [p, h] = to.split("#");
      navigate(p || "/");
      setTimeout(() => document.getElementById(h)?.scrollIntoView({ behavior: "smooth" }), 150);
    } else {
      if (window.location.pathname === to) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        navigate(to);
      }
    }
  };

  return (
    <header data-testid="site-nav" className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#F9F9F8]/80 border-b border-[#1A1A1A]/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button onClick={() => go("/")} data-testid="nav-logo" className="font-serif text-2xl md:text-3xl tracking-tight italic">
          Bahare
        </button>
        <nav className="hidden lg:flex items-center gap-5">
          {LINKS.map((l) => (
            <button key={l.label} onClick={() => go(l.to)} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-[11px] uppercase tracking-[0.2em] text-[#4A4A4A] hover:text-[#1A1A1A] transition-colors duration-300">
              {l.label}
            </button>
          ))}
          <button onClick={() => go("/book")} data-testid="nav-book-btn"
            className="ml-4 text-[11px] uppercase tracking-[0.2em] bg-[#1A1A1A] text-[#F9F9F8] px-6 py-3 rounded-full hover:bg-[#4A4A4A] transition-colors duration-300">
            Book a Session
          </button>
        </nav>
        <div className="flex lg:hidden items-center gap-3">
          <button onClick={() => go("/book")} data-testid="nav-book-btn-mobile"
            className="text-[10px] uppercase tracking-[0.18em] bg-[#1A1A1A] text-[#F9F9F8] px-4 py-2.5 rounded-full">
            Book
          </button>
          <button onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label="Menu">
            {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.25 }} className="lg:hidden border-t border-[#1A1A1A]/5 bg-[#F9F9F8]/95 backdrop-blur-xl">
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button key={l.label} onClick={() => go(l.to)} data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-left font-serif text-2xl text-[#1A1A1A]">
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
